<template>
  <b-modal id="modal-2" size="lg">
    <!--Body-->
    <!-- <div class="modal-body"> -->
    <template slot="default">
      <b-container fluid>
        <b-row>
          <b-col lg="12">
            <slot name="header"></slot>
          </b-col>
        </b-row>
        <b-row class="mt-4 mb-4">
          <b-col lg="12">
            <slot name="body"></slot>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="12">
            <slot name="details"></slot>
          </b-col>
        </b-row>
      </b-container>
    </template>
    <!-- </div> -->

    <!-- Footer-->
    <template slot="modal-footer">
      <div
        slot
        class="modal-footer justify-content-center"
        style="border:none;"
      >
        <a
          type="button"
          class="btn btn-primary text-white"
          @click="$bvModal.hide('modal-2')"
        >
          Done
        </a>
      </div>
    </template>

    <!--/.Content-->
  </b-modal>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  computed: {
    ...mapState(["n_user"]),
    ...mapActions("n_user", ["Delete"]),
    ...mapActions("n_user", ["DeleteUserGroup"])
  },
  methods: {},
  props: {
    CurrentObject: Object,
    EntityType: ""
  },
  updated() {}
};
</script>
<style scoped>
.myclass > div {
  position: absolute !important;
  top: -10px !important;
  left: -10px !important;
  background-color: yellow !important;
}

.myclass > .modal-dialog > .modal-content {
  background-color: red !important;
}
</style>
